import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { Button, Card, Icon, Segment, Table } from "semantic-ui-react";

import { DownloadLink } from "simplydo/react/components/DownloadLink";

import util from "utils/utils";

import { FileChooserWithDropzone } from "components/lib/Choosers";

import { FieldProps } from "./FieldProps";

type FileComponentProps = {
  files: Array<{ name: string; value: string }>;
  onRemove?: (fileId: string) => void;
};

export const FileComponent = ({ files, onRemove }: FileComponentProps) => {
  const { t } = useTranslation();

  return (
    <Card.Group centered onClick={(e) => e.stopPropagation()}>
      <Card style={{ width: "80%" }}>
        <Card.Content style={{ color: "#808080" }}>
          <Icon name="file alternate outline" />
          {util.pluralise(files.length, "uploaded file", "uploaded files")}
        </Card.Content>
        <Card.Content textAlign="center">
          <Table basic="very">
            <Table.Body>
              {files.map((file) => (
                <Table.Row key={file.value}>
                  <Table.Cell collapsing style={{ padding: 0 }}>
                    <Icon
                      name="file"
                      size="large"
                      style={{ color: "#808080" }}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <DownloadLink url={file.value} name={file.name}>
                      {file.name}
                    </DownloadLink>
                  </Table.Cell>

                  <Table.Cell collapsing>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "0.25rem",
                      }}
                    >
                      <DownloadLink url={file.value} name={file.name}>
                        <Button
                          basic
                          icon="download"
                          content={t("generic.download")}
                          size="tiny"
                          style={{ marginLeft: 0, marginRight: 0 }}
                        />
                      </DownloadLink>

                      {onRemove ?
                        <Button
                          basic
                          icon="trash"
                          onClick={() => onRemove(file._id)}
                          size="tiny"
                          style={{ marginLeft: 0, marginRight: 0 }}
                        />
                      : null}
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
    </Card.Group>
  );
};

const File = ({
  field,
  ideaId,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  if (!isEditing) {
    if (fieldValue) return <FileComponent files={[fieldValue]} />;
    return null;
  }

  if (fieldValue) {
    return (
      <Segment placeholder>
        <FileComponent
          files={[fieldValue]}
          onRemove={() => updateIdea(null, ["templated", field.id])}
        />
      </Segment>
    );
  }

  return (
    <FileChooserWithDropzone
      forType="idea"
      forId={ideaId}
      onComplete={(_, fileName, imageSrc) => {
        updateIdea({ value: imageSrc, name: fileName }, [
          "templated",
          field.id,
        ]);
      }}
      onError={toast.error}
      popupProps={{ position: "bottom center" }}
      dropzoneProps={{
        title: "Upload a file",
        DropZoneComponent: Segment,
        defaultIcon: "file",
      }}
    />
  );
};

export default File;
